import { addNewCellToRow } from '@modules/dashboard/components/Layout/DashboardCell/helpers/addNewCellToRow';
import { removeCellFromRow } from '@modules/dashboard/components/Layout/DashboardCell/helpers/removeCellFromRow';
import { DashboardCell } from 'generated/graphql';

export function handleDropInAnotherRow({
  dropTargetIdx,
  draggedCell,
  sourceRowCells,
  destinationRowCells,
}: {
  dropTargetIdx: number;
  draggedCell: DashboardCell;
  sourceRowCells: DashboardCell[];
  destinationRowCells: DashboardCell[];
}) {
  const draggedCellIdx = sourceRowCells.findIndex(
    (cell) => cell.id === draggedCell.id,
  );

  addNewCellToRow(destinationRowCells, draggedCell, dropTargetIdx);
  removeCellFromRow(sourceRowCells, draggedCellIdx);
}
